(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.pd-rich__content').forEach(function (root) {
      var imgs = Array.prototype.slice.call(root.querySelectorAll('img'));
      if (imgs.length < 1) return;

      function process() {
        var gridImgs = [];

        imgs.forEach(function (img) {
          var w = img.naturalWidth || 0;
          var h = img.naturalHeight || 0;
          // Wide landscape images (size charts) stay in the text flow
          if (w && h && (w / h) > 1.15) {
            img.classList.add('pd-chart');
          } else {
            // Everything else (product photos) goes to the grid
            gridImgs.push(img);
          }
        });

        if (gridImgs.length < 1) return;

        var grid = document.createElement('div');
        grid.className = 'pd-rich__images';
        root.appendChild(grid);
        gridImgs.forEach(function (img) {
          grid.appendChild(img);
        });
      }

      var pending = imgs.filter(function (i) { return !i.complete || !i.naturalWidth; });
      if (pending.length === 0) {
        process();
      } else {
        var loaded = 0, total = pending.length;
        pending.forEach(function (img) {
          img.addEventListener('load', done);
          img.addEventListener('error', done);
        });
        function done() {
          loaded++;
          if (loaded >= total) process();
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
